import "./loading.css";

const Loading = () => (
  <>
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="pulsating"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.80304 0H48.197C51.3861 0 54 2.60986 54 5.8035V48.2008C54 51.3901 51.3904 54 48.197 54H5.80304C2.61394 54 0 51.3901 0 48.2008V5.8035C0 2.60986 2.60965 0 5.80304 0Z"
        fill="#7600ED"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.6869 43.027L13.6595 30.2767L40.0438 30.2221C39.9252 33.6189 40.4954 37.0929 34.3418 37.1339H23.7042L23.6768 46.0327H29.7802L31.2719 42.9725C38.5887 42.5905 45.5041 42.6769 47.0961 33.4733C47.3698 31.8818 47.388 25.252 47.2922 23.474L13.7644 23.4558C13.6504 20.5729 13.7644 18.3175 16.7477 16.9852C18.0022 16.4259 33.3656 16.485 35.1401 16.5941C37.4756 16.7305 39.647 17.1352 40.0028 19.6453L47.3606 19.6589C47.0824 17.8537 46.3708 16.3667 45.5816 15.0799C43.6749 11.965 40.1761 9.21853 36.4584 8.71379C32.1203 8.12265 25.3235 8.57737 20.4745 8.56828C16.1638 8.55918 14.1522 8.51371 10.8085 11.2329C8.18558 13.1473 6.8764 15.7483 6.19672 18.6767L6.27883 26.3024L6.22865 33.5779C6.21952 34.9739 6.80341 36.3154 7.61538 37.7705C7.84346 38.1797 8.11715 38.6026 8.4319 39.0346C9.32142 40.2441 9.03404 39.8667 9.87793 40.6534C10.6808 41.4037 12.1496 42.2404 13.6778 43.0316"
        fill="#F1E6FD"
      />
    </svg>
  </>
);

export default Loading;
